<template>
  <div>
    <page-header :title="$t('bill.daily_bill_detail')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv">
      <div slot="res-status-tab">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <bill-detail-list :id="listId" :cloud-env="cloudEnv" :billShared="billShared" :projectShared="projectShared" @updateBillShared="updateBillShared" @updateProjectShared="updateProjectShared" />
    </page-body>
  </div>
</template>

<script>
import currencyMixin from '@Bill/mixins/currency'
import { getCloudEnvOptions } from '@/utils/common/hypervisor'
import BillConfig from '@Bill/sections/BillConfig'
import shareMixin from '@Bill/mixins/share'
import BillDetailList from './components/List'

export default {
  name: 'BillDetailIndex',
  components: {
    BillDetailList,
    BillConfig,
  },
  mixins: [currencyMixin, shareMixin],
  data () {
    return {
      listId: 'BillDetailList',
      cloudEnvOptions: getCloudEnvOptions('brands'),
      cloudEnv: '',
    }
  },
}
</script>
